import React from 'react'
import { Marker as LeafletMarker, Popup as LeafletPopup, useMap } from 'react-leaflet'
import { useTranslation } from 'react-i18next'
import { tr } from 'i18n'
export * from 'react-leaflet'

export function Marker(props) {
  const { i18n } = useTranslation()
  return <LeafletMarker key={i18n.language} alt={tr('Метка на карте')} title={tr('Метка на карте')} {...props} />
}
function ClosePopup() {
  useTranslation()
  const map = useMap()
  return <button type="button" className="leaflet-popup-close-button" title={tr('Закрыть окно карты')} aria-label={tr('Закрыть окно карты')} onClick={() => map.closePopup()}>×</button>
}
export function Popup({ children, ...props }) {
  return <LeafletPopup {...props} closeButton={false}><ClosePopup />{children}</LeafletPopup>
}
